import { Drawer } from 'antd';
import React from 'react';
import styles from './Filter.module.scss';
import { ReactComponent as FilterIcon } from '../../../../../../resource/FilterIcon.svg';
import { useSelector } from 'react-redux';
import { selectVisible } from '../../../../features/filterNew/model/selectors';
import useFilterVisible from '../../../../features/filterNew/hooks/useFilterVisible';
import { Footer } from '../../../../features/filterNew/footer';
import { BodyFilter } from '../../../../features/filterNew/body';

const FilterHeader = () => {
  return (
    <div className={styles.header}>
      <FilterIcon />
      <div>Фильтр отключений</div>
    </div>
  );
};

const Filter = () => {
  const visible = useSelector(selectVisible);

  const { onClose } = useFilterVisible();

  return (
    <Drawer
      visible={visible}
      width="40%"
      headerStyle={{ position: 'sticky', top: 0, zIndex: 10 }}
      title={<FilterHeader />}
      closable={true}
      drawerStyle={{ backgroundColor: '#F3F7FF' }}
      bodyStyle={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: 0,
      }}
      onClose={onClose}
    >
      <div style={{ flex: 1 }}>
        <BodyFilter />
      </div>
      <Footer />
    </Drawer>
  );
};

export default Filter;
